import { api, call } from '../../api/client';
import { useAction } from '../../api/queries';
import { useHousehold } from '../../api/session';

type Simple = 'claim' | 'return-to-pool' | 'reopen' | 'archive' | 'skip' | 'take-over' | 'withdraw-from-child' | 'hand-back-to-child';

const SIMPLE_PATHS = {
  claim: '/api/v1/families/{familyId}/tasks/{taskId}/claim',
  'return-to-pool': '/api/v1/families/{familyId}/tasks/{taskId}/return-to-pool',
  reopen: '/api/v1/families/{familyId}/tasks/{taskId}/reopen',
  archive: '/api/v1/families/{familyId}/tasks/{taskId}/archive',
  skip: '/api/v1/families/{familyId}/tasks/{taskId}/skip',
  'take-over': '/api/v1/families/{familyId}/tasks/{taskId}/take-over',
  'hand-back-to-child': '/api/v1/families/{familyId}/tasks/{taskId}/hand-back-to-child',
} as const;

/** All task commands. The server re-validates every one; buttons only appear for `allowedActions`. */
export function useTaskCommands() {
  const { familyId } = useHousehold();
  const params = (taskId: string) => ({ params: { path: { familyId, taskId } } });

  const simple = useAction(({ action, taskId }: { action: Simple; taskId: string }) => {
    if (action === 'withdraw-from-child') {
      return call(api.POST('/api/v1/families/{familyId}/tasks/{taskId}/withdraw-from-child', { ...params(taskId), body: {} }));
    }
    return call(api.POST(SIMPLE_PATHS[action], params(taskId)));
  });
  const complete = useAction(({ taskId, claimIfUnassigned }: { taskId: string; claimIfUnassigned?: boolean }) =>
    call(api.POST('/api/v1/families/{familyId}/tasks/{taskId}/complete', { ...params(taskId), body: { claimIfUnassigned } })),
  );
  return { simple, complete };
}

/** The single most useful action for a task card. */
export function primaryAction(allowed: string[]): { label: string; action: Simple | 'complete' | 'claim-and-complete' } | null {
  if (allowed.includes('CLAIM')) return { label: "I'll do this", action: 'claim' };
  if (allowed.includes('COMPLETE')) return { label: 'Done', action: 'complete' };
  if (allowed.includes('REOPEN')) return { label: 'Reopen', action: 'reopen' };
  return null;
}
